import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type CardType = {
    id: number
    title: string  
    card: any
}

type CardTypeDto = {
    title: string  
}

export const CardTypesApi = createApi({
    reducerPath: 'CardTypesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getCardType: builder.query<CardType, { id: number }>({
            query: id => ({ url: `/card-types/${id}` })
        }),
        getAllCardTypes: builder.query<CardType[], void>({
            query: () => ({ url: '/card-types' })
        }),
        createCardType: builder.mutation<any, CardTypeDto>({
            query: (data)=> ({url: `/card-types`, method: "POST", body: data}),
        }),
    })
})

export const { useGetCardTypeQuery, useGetAllCardTypesQuery, useCreateCardTypeMutation } = CardTypesApi
